import { Button, Col, Divider, Modal, Row, Table, Tag, Typography } from "antd";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getColumnSearchProps } from "../../utils";
import { IPlanoGovernoEixo, IPlanoGovernoEixoMeta } from "../../interfaces";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

interface ITableEixo {
    handleCreateOrEditEixo: (uuid?: string) => void,
    onClickDelete: (uuid: string) => void,
    eixos: IPlanoGovernoEixo[],
    isLoading: boolean,
    refContagemDoFiltro: React.MutableRefObject<any[]>
}

function TableEixo({ handleCreateOrEditEixo, onClickDelete, eixos, isLoading, refContagemDoFiltro }: ITableEixo) {
    const navigate = useNavigate();
    const columnsEixo = [
        {
            title: "Eixo",
            dataIndex: "descricao",
            key: "descricao",
            width: "40%",
            sorter: (a: any, b: any) => a.descricao.localeCompare(b.descricao),
            ...getColumnSearchProps("descricao"),
            showSorterTooltip: false,
        },
        {
            title: "Objetivo",
            dataIndex: "objetivo",
            key: "objetivo",
            width: "25%",
            sorter: (a: any, b: any) => a.objetivo.localeCompare(b.objetivo),
            ...getColumnSearchProps("objetivo"),
            showSorterTooltip: false,
            render: (val?: string | null) => {
                return (
                    <span>
                        {val && val?.length > 40 ?
                            val?.substring(0, 40) + '...' : val}
                    </span>
                );
            },
        },
        {
            title: "Metas",
            dataIndex: "metas",
            key: "metas",
            width: "10%",
            sorter: (a: any, b: any) => a.metas.length - b.metas.length,
            showSorterTooltip: false,
            render: (val: IPlanoGovernoEixoMeta[]) => {
                return (
                    <span>
                        <Tag color={"blue"} key={val.length}>
                            {val.length}
                        </Tag>
                    </span>
                );
            },
        },
        {
            title: "Ações",
            dataIndex: "uuid",
            key: "uuid",
            width: "10%",
            render: (uuid: string, record: IPlanoGovernoEixo) => (
                <span>
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        size="small"
                        onClick={() => handleCreateOrEditEixo(record.uuid)}
                    >
                        <FaEdit />
                    </Button>
                    <Divider type="vertical" />
                    <Button
                        style={{
                            borderRadius: 5,
                            margin: 1,
                        }}
                        type="primary"
                        danger
                        size="small"
                        onClick={() => {
                            onClickDelete(uuid);
                        }}
                    >
                        <FaTrash />
                    </Button>
                </span>
            ),
        },
    ];


    return (
        <>
            <Row style={{ marginTop: 10, marginBottom: 30 }} gutter={16}>
                <Col
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Button
                        type="primary"
                        onClick={() => navigate('/plano-de-governo/eixo/cadastrar')}
                    >
                        <FaEdit />
                        Adicionar Eixo
                    </Button>
                </Col>
            </Row>
            <Table
                columns={columnsEixo}
                dataSource={eixos}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: "end",
                            }}
                        >
                            <Typography>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length
                                    } de ${refContagemDoFiltro
                                        .current.length === 0
                                        ? eixos.length
                                        : refContagemDoFiltro
                                            .current.length
                                    } num total de ${eixos.length
                                    } `}
                            </Typography>
                        </div>
                    );
                }}
                scroll={{ x: 700 }}
                pagination={{
                    locale: { items_per_page: "" },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    position: ["bottomRight"],
                    pageSizeOptions: ["10", "20", "50", "100"],
                }}
                // rowSelection={rowSelection}
                loading={isLoading}
                rowKey={Math.random}>

            </Table>
        </>)
}

export default memo(TableEixo);
